export default {
  OK: "OK",
  CANCEL: "Cancel",
  CLOSE: "Close",
  inputHere: "Input here...",
  send: "Send",
  finishSession: "Finish session",
  createSession: "A conversation is being created,please wait a moment",
  withDrawned: "WithDrawn",
  serviceSys: "Service system",
  haveread: "Have Read",
  unread: "Unread",
  noMoreHistoryLog: "No more history",
  confirmRecall: "Confirm to withdraw current message?",
  expression: "Expression",
  GIF: "GIF",
  sendfile: "Send file",
  satisfyEvaluation: "Satisfy Evaluation",
  message: "Message",
  inputContent: "Please enter content",
  selectSkill:
    "Please select the customer service skill group to be transferred",
  clickToSelectSkill: "Click group to transfer customer service",
  clickDownload: "Download files",
  doseNotsupportVideo: "Your browser dose not support the video tag.",
  peakPeriod: "Peak period of consultation",
  refreshQueue: "refresh the queue status",
  isSolved: "Is the problem solved?",
  solved: "Solved",
  unsolved: "Unsolved",
  dissatisfyReason: "Select dissatisfaction reason:",
  commentService: "Please comment on this service",
  uploadFile: "Upload file",
  verySatisfied: "Excellent",
  satisfied: "Good",
  general: "Average",
  notSatisfied: "Poor",
  veryDissatisfied: "Very Poor",
  uploading: "Uploading...",
  icon: "Icon",
  submitFeed: "Submit feedback",
  loading: "Loading...",
  msgHaveWithDrawned: "Message have Withdrawn",
  afterSale: "After sale the following products",
  loadMore: "Load more",
  talkHere: "Last time talk here",
  holdToSpeak: "Hold to speak",
  sendImg: "Send image",
  takeAVideo: "Take a video",
  feedback: "Feedback",
  questionIsSolve: "Has the problem been solved this time?",
  pleaseEnter: "Please enter ",
  pleaseSelect: "Please select ",
  enterCorrectPhone: "Please enter the correct phone number",
  enterCorrectEmail: "Please enter the correct E-mail",
  phoneFormat: "Phone format",
  emailFormat: "E-mail format",
  enterNum: "Please enter the number",
  number: "Number",
  enterEnglish: "Please enter English",
  english: "English",
  enterChinese: "Please enter Chinese",
  chinese: "Chinese",
  enterSpecial: "Please enter special characters",
  special: "Special characters",
  onlyEnter: "Only enter ",
  lengthNotExceed: "Length must not exceed",
  reset: "Reset",
  resetNbsp: "Reset",
  submit: "Submit",
  submitNbsp: "Submit",
  successful: "Successful",
  fail: "Failed",
  feedSuccessful:
    "The feedback is submitted successful,click the upper left corner to close the page",
  messageTitle: "Message title",
  exitQueue: "Whether to determine the exit queue",
  exitSuccess: "Exit queue successfully",
  exitFailed: "Exit queue failed",
  meassageHasBeenRevoked: 'This message has been withdrawn',    
  messageDetails: 'Message details',
  messageSendTime: 'Message sendtime',
  img: 'Image',
  video: 'Video',
  voice: 'Voice'
};
